<template>
    <div class="c-collapse-wrapper mb-3">
        <div class="c-collapse">
            <div class="collapse-header">
                <div
                    class="w-100"
                    data-toggle="collapse"
                    data-target="#customilyCollapse"
                    aria-controls="customilyCollapse"
                >
                    <span class="title">{{ title }}</span>
                </div>
                <slot name="header" />
            </div>
            <div id="customilyCollapse" class="collapse show">
                <div ref="contentRef" :style="{ maxHeight: `${itemContainerSize}px` }">
                    <slot />
                </div>
            </div>
        </div>
        <div v-if="resizable" class="item-container-size" @mousedown="onStartResizeItemContainerSize">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <circle cx="12" cy="9" r="1" />
                <circle cx="19" cy="9" r="1" />
                <circle cx="5" cy="9" r="1" />
                <circle cx="12" cy="15" r="1" />
                <circle cx="19" cy="15" r="1" />
                <circle cx="5" cy="15" r="1" />
            </svg>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { Ref, onUnmounted, ref } from 'vue';

defineProps<{
    title?: string;
    resizable?: boolean;
}>();

const contentRef: Ref<Element | null> = ref(null);
const itemContainerSize = ref(250);

onUnmounted(() => {
    onStopResizeItemContainerSize();
});

const onStartResizeItemContainerSize = () => {
    window.addEventListener('mousemove', onHandleResizeItemContainerSize);
    window.addEventListener('mouseup', onStopResizeItemContainerSize);
};

const onHandleResizeItemContainerSize = (event: MouseEvent) => {
    const newHeight = event.clientY - contentRef.value!.getBoundingClientRect().bottom;

    if (newHeight === Infinity || newHeight === -Infinity) return;

    const newHeightContainer = itemContainerSize.value + newHeight;
    const controlHeight = document.querySelector('.layout-main')?.getBoundingClientRect().height || 0;

    if (newHeightContainer > controlHeight) return;

    itemContainerSize.value = newHeightContainer;
};

const onStopResizeItemContainerSize = () => {
    window.removeEventListener('mousemove', onHandleResizeItemContainerSize);
    window.removeEventListener('mouseup', onStopResizeItemContainerSize);
};
</script>

<style lang="scss" scoped>
.c-collapse-wrapper {
    .c-collapse {
        border: 1px solid #dddddd;
        border-radius: 3px;
        .collapse-header {
            display: flex;
            align-items: center;
            padding: 0.63rem 0.85rem;
            background-color: #f5f5f5;
            border-bottom: 1px solid #dddddd;
            .title {
                font-size: 1rem;
                cursor: pointer;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
        .collapse {
            overflow-y: auto;
            overflow-x: hidden;
            box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
        }
    }

    .item-container-size {
        text-align: center;
        cursor: row-resize;
    }
}
</style>
